// extracted by mini-css-extract-plugin
export default {"TableRow":"Fornitore_TableRow__R2Kxk"};